export default __webpack_public_path__ + "static/media/1.4ecddc5b.webp";